import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import Checkbox from '@material-ui/core/Checkbox';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";
import {ValidateImageMatchSize, ValidateImage, ValidateImageArray} from '../utils/validateImage'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class ProjectDetail extends Component {
    fileObj = [];
    fileArray = [];
    filePlan = [];

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
        document.addEventListener('fchange', (e) => {
            this.clearFileInState(e.detail)
        })
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            pages: [],
            user_permission: user_permission,
            project_type_pages: [{ value: '', display: 'เลือกประเภทแบรนด์' }],
            home_type_pages: [{ value: '', display: 'เลือกประเภทบ้าน' }],
            project_homes_pages: [{ value: '', display: 'เลือกประเภทโครงการ' }],
            project_home: [],
            project_types: [],
            jwt: jwt,
            miss_su: helpers.getUserType(user_type, "su"),
            create_by: name,
            create_by_id: user_id,
            user_type: user_type,
            user_id: user_id,
            page: 0,
            rowsPerPage: 10,
            addIsOpen: false,
            updateIsOpen: false,
            srcIsOpen: false,
            methodOpen: 'add',
            file: [],
            filePlans: [null],
            file_ImageProject: null,
            file_ImagePlan: null,
            file_ImageMap: null,
            active: true,
            imgCollection: '',
            imgCollectionPlans:'',
            content_id: '',
            src_active: false,
            src_nonactive: false,
            add_home_type: '',
            add_project_type: '',
            add_project_name: '',
            add_banner: '',
            ImageProject: '',
            ImageBanner: '',
            add_linkBanner: '',
            add_lineKwanjai: '',
            add_concept: '',
            add_linkMore: '',
            add_latitude: '',
            add_longitude: '',
            add_home_name: '',
            add_projectname_name: '',
            ImageMap: '',
            add_linkVideo: '',
            add_VideoDescription: '',
            add_active_status: '',
            add_project_home:'',
            spinner: false,
            values: [{ link: "", description: "", type_video: "link" }],
            plans: [{ img: "", description: "", type: "link" }],
            plansObj: [null],
            changeIndexUpload: -1,
            imgGalleryPreviewArr: [],
            edit_id: '',
            previewBanner:null,
            previewProject: null,
            previewGallery: [],
            previewMap: null,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable();

        this.change = this.change.bind(this);
        this.changeHomeType = this.changeHomeType.bind(this);
        this.changeProjectType = this.changeProjectType.bind(this);

        this.openAdd = this.openAdd.bind(this);
        this.closeAdd = this.closeAdd.bind(this);

        this.openView = this.openView.bind(this);

        this.openEdit = this.openEdit.bind(this);

        this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
        this.uploadMultipleFilesPlans = this.uploadMultipleFilesPlans.bind(this);

        this.submitAdd = this.submitAdd.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.handleCheck = this.handleCheck.bind(this)

        this.closeUpdate = this.closeUpdate.bind(this);

        this.openDelete = this.openDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);


        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);


        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)

        this.onChangeImgProject = this.onChangeImgProject.bind(this)
        this.onChangeImgBanner = this.onChangeImgBanner.bind(this)
        this.onChangeImgMap = this.onChangeImgMap.bind(this)

        this.home_type()
        this.project_homes()
        this.project_types()
    }

    clearFileInState(i) {
        document.getElementsByClassName('planImgs')[i].value = ''
    }

    home_type() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/home_types', requestOptions)
                .then(res => res.json())
                .then(data => {
                    let sortData = data.data.sort(function (a, b) {
                        return b.num - a.num;
                    });
    
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });
    
                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });
    
                    this.setState({
                        home_type_pages: [{ value: '', display: 'เลือกประเภทบ้าน' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    project_type(home_types_id) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            if (home_types_id) {
                let body = `?home_type_id=${home_types_id}`
                fetch(config.url.API_URL + '/project_typesSrc/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return b.num - a.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
    
                        this.setState({
                            project_type_pages: [{ value: '', display: 'เลือกแบรนด์' }].concat(FromApi)
                        });
    
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    })
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    project_homes() {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    })
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    })
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    project_types() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_types', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    let sortData = data.data.sort(function (a, b) {
                        return b.num - a.num;
                    });
    
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });
    
                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });
                    this.setState({
                        project_types: [{ value: '', display: 'เลือกแบรนด์' }].concat(FromApi)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    project_home(project_types_id) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            let body = `?project_type_id=${project_types_id}`
            fetch(config.url.API_URL + '/project_homesSrc/' + body, requestOptions)
                .then(res => res.json())
                .then(async (data) => {
                    console.log("Proj Home ",data.data)
                    let sortData = data.data.sort(function (a, b) {
                        return b.num - a.num;
                    });
                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });
    
                    let FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });
    
                    await this.setState({
                        project_homes_pages: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi),
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = ``
            }
    
            let body = `?projecthomeid=${project_id}`
            fetch(config.url.API_URL + '/project_detail' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    dataTableSrc() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            let body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&name=${this.state.add_name}&projecttypeid=${this.state.src_project_type}&projectid=${this.state.src_project_name}`
    
            fetch(config.url.API_URL + '/project_detailSrc' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openAdd() {
        this.fileObj = [];
        this.fileArray = [];
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            active: true,
            add_home_type: '',
            add_project_type: '',
            add_project_name: '',
            add_home_name: '',
            add_project_name: '',
            add_projectname_name: '',
            add_banner: '',
            ImageProject: '',
            ImageBanner: '',
            add_banner: '',
            add_linkBanner: '',
            add_lineKwanjai: '',
            add_concept: '',
            add_linkMore: '',
            add_latitude: '',
            add_longitude: '',
            ImageMap: '',
            add_linkVideo: '',
            add_VideoDescription: '',
            add_active_status: '',
            file: [null],
            file_ImageProject: null,
            file_ImageBanner: null,
            file_ImageMap: null,
            fileObj: [],
            fileArray: [],
            values: [{ link: "", description: "", type_video: "link" }],
            plans: [{ img: "", description: "", type: "link" }],
            imgGalleryPreviewArr: [],
            previewBanner:null,
            previewProject: null,
            previewGallery: [],
            previewMap: null,
        });
    }

    closeAdd() {
        this.setState({ addIsOpen: false });
    }

    submitAdd() {
        try {
            this.setState({ addIsOpen: true, spinner: true });

            if(!this.state.add_home_type){
                alert('ไม่พบข้อมูลประเภทโครงการ');
                this.setState({ spinner: false });
                return;
            }
            if(!this.state.add_project_type){
                alert('ไม่พบข้อมูลโครงการ');
                this.setState({ spinner: false });
                return;
            }
            if(!this.state.add_project_name){
                alert('ไม่พบข้อมูลชื่อโครงการ');
                this.setState({ spinner: false });
                return;
            }
            if (!this.state.add_banner) {
                alert('ไม่พบข้อมูลชื่อแบนเนอร์');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.add_home_type) {
                alert('ไม่พบข้อมูลประเภทบ้าน');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.add_project_type) {
                alert('ไม่พบข้อมูลประเภทโครงการ');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.add_project_name) {
                alert('ไม่พบข้อมูลโครงการ');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.file_ImageProject) {
                alert('ไม่พบข้อมูลภาพโครงการ');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.file_ImageBanner) {
                alert('ไม่พบข้อมูลรูปแบนเนอร์');
                this.setState({ spinner: false });
                return;
            }
    
            if (!this.state.add_linkBanner) {
                alert('ไม่พบข้อมูลลิงก์แบนเนอร์');
                this.setState({ spinner: false });
                return;
            }
    
            // if (!this.state.add_lineKwanjai) {
            //     alert('ไม่พบข้อมูล Line Kwanjai');
            //     this.setState({ spinner: false });
            //     return;
            // }
    
            if(!this.state.imgCollection){
                alert('ไม่พบข้อมูล Gallery');
                this.setState({ spinner: false });
                return;
            }
    
            // if(!this.state.add_imgmap){
            //     alert('ไม่พบข้อมูล Map Graphic');
            //     this.setState({ spinner: false });
            //     return;
            // }
            // if(this.state.values.length == 0 || this.state.values[0]?.link === ''){
            //     alert('ไม่พบข้อมูล วีดีโอ');
            //     this.setState({ spinner: false });
            //     return;
            // }
    
            // if(!this.state.imgCollectionPlans){
            //     alert('ไม่พบข้อมูล รูปแปลน');
            //     this.setState({ spinner: false });
            //     return;
            // }
    
            const formData = new FormData();
            formData.append('title', this.state.add_banner)
            formData.append('home_type_id', this.state.add_home_type)
            formData.append('project_type_id', this.state.add_project_type)
            formData.append('project_home_id', this.state.add_project_name)
            formData.append('link', this.state.add_linkBanner)
            formData.append('line_kwanjai', this.state.add_lineKwanjai)
            formData.append('concept_detail', this.state.add_concept)
            formData.append('link_detail', this.state.add_linkMore)
            formData.append('latitude', this.state.add_latitude)
            formData.append('longitude', this.state.add_longitude)
            // formData.append('videos', JSON.stringify(this.state.values))
            // formData.append('plans', JSON.stringify(this.state.plans))
            formData.append('ImgProject', this.state.file_ImageProject)
            formData.append('ImgBanner', this.state.file_ImageBanner)
            formData.append('ImgMap', this.state.add_imgmap)
            formData.append('active_status', this.state.active ? 1 : 0)
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
            
            for (const key of Object.keys(this.state.imgCollection)) {
                formData.append('myImage', this.state.imgCollection[key])
            }
            
            // for (const key of Object.keys(this.state.imgCollectionPlans)) {
            //         formData.append('planImage', this.state.imgCollectionPlans[key])
            // }
                
            // const newPlan = this.state.plans.filter(item => item != null)
            // formData.append('plans', JSON.stringify(newPlan))
    
            // for (let i = 0; i < this.state.plansObj.length; i ++) {
            //     if(this.state.plansObj && this.state.plansObj[i] != null) formData.append('planImage', this.state.plansObj[i])
            // }
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/project_detail', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if(data.status == "Success"){
                        this.setState({
                            updateIsOpen: true,
                            spinner: false,
                            file: [null],
                            file_ImageProject: null,
                            file_ImageBanner: null,
                            file_ImageMap: null,
                        });
                    }else{
                        this.setState({
                            spinner: false,
                            file: [null],
                            file_ImageProject: null,
                            file_ImageBanner: null,
                            file_ImageMap: null,
                        });
                        alert(data.message)
                    }
                }).catch(error => {
                    console.log(error)
                    this.setState({
                        spinner: false,
                        file: [null],
                        file_ImageProject: null,
                        file_ImageBanner: null,
                        file_ImageMap: null,
                    });
                    alert(error.message)
                });
    
            this.setState({ addIsOpen: false, spinner: true });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            this.fileArray = []
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_detail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
                    this.setState({
                        add_home_name: data.home_type_name,
                        add_project_name: data.project_type_name,
                        add_projectname_name: data.project_name,
                        add_banner: data.title,
                        add_linkBanner: data.linkbanner,
                        add_lineKwanjai: data.linekwanjai,
                        add_concept: data.concept,
                        add_linkMore: data.linkmore,
                        add_latitude: data.latitude,
                        add_longitude: data.longitude,
                        add_imgbanner: data.img,
                        add_img: data.project_img,
                        add_active_status: data.active_status,
                        active: data.active,
                        add_imgmap: data.img_map,
                        imgGalleryPreviewArr: data.gallerys,
                        // add_linkVideo: data.videolink,
                        // add_VideoDescription: data.videodescription,
                        add_img_gallerys: data.gallerys,
                        // values: data.videos,
                        // plans: data.plans
                    });
                    if (this.state.add_img_gallerys.length > 0) {
                        for (let i = 0; i < this.state.add_img_gallerys.length; i++) {
                            this.fileArray.push(this.state.add_img_gallerys[i]['image'])
                        }
                    }
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openEdit(e) {
        try {
            this.setState({plans: [{ img: "", description: "", type: "link" }],edit_id:e.currentTarget.attributes["data-id"].value,imgGalleryPreviewArr:[]})
            this.fileObj = [];
            this.fileArray = [];
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_detail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    const data = dataDetail.data;
                    const test = data.gallerys.map(item => {return item.image})
                    this.setState({
                        add_home_name: data.home_type_name,
                        add_project_name: data.project_type_name,
                        add_projectname_name: data.project_name,
                        add_id: data.id,
                        add_home_type: data.home_type_id,
                        add_project_type: data.project_type_id,
                        add_project_home: data.project_id,
                        add_banner: data.title,
                        add_linkBanner: data.linkbanner,
                        add_lineKwanjai: data.linekwanjai,
                        add_concept: data.concept,
                        add_linkMore: data.linkmore,
                        add_latitude: data.latitude,
                        add_longitude: data.longitude,
                        add_imgbanner: data.img,
                        add_img: data.project_img,
                        add_active_status: data.active_status,
                        add_imgmap: data.img_map,
                        previewGallery: test,
                        previewProject: data.project_img,
                        previewBanner: data.img,
                        previewMap: data.img_map
                        // values: data.videos,
                        // plans: data.plans
                    });
                    // this.project_type(this.state.add_home_type)
                    // this.project_home(this.state.add_project_type)
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit',
                        imgCollection: '',
                        imgCollectionPlans:''
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitEdit(e) {
        try {
            if(!this.state.add_home_type){
                alert('ไม่พบข้อมูลประเภทโครงการ');
                return;
            }
            if(!this.state.add_project_type){
                alert('ไม่พบข้อมูลโครงการ');
                return;
            }
            if(!this.state.add_project_name){
                alert('ไม่พบข้อมูลชื่อโครงการ');
                return;
            }
            if (!this.state.add_banner) {
                alert('ไม่พบข้อมูลชื่อแบนเนอร์');
                return;
            }
    
            if (!this.state.add_home_type) {
                alert('ไม่พบข้อมูลประเภทบ้าน');
                return;
            }
    
            if (!this.state.add_project_type) {
                alert('ไม่พบข้อมูลประเภทโครงการ');
                return;
            }
    
            if (!this.state.add_project_name) {
                alert('ไม่พบข้อมูลโครงการ');
                return;
            }
    
            // if (!this.state.file_ImageProject) {
            //     alert('ไม่พบข้อมูลภาพโครงการ');
            //     return;
            // }
    
    
            if (!this.state.add_linkBanner) {
                alert('ไม่พบข้อมูลลิงก์แบนเนอร์');
                return;
            }
    
    
    
            const formData = new FormData();
            formData.append('title', this.state.add_banner)
            formData.append('home_type_id', this.state.add_home_type)
            formData.append('project_type_id', this.state.add_project_type)
            formData.append('project_home_id', this.state.add_project_home)
            formData.append('link', this.state.add_linkBanner)
            formData.append('line_kwanjai', this.state.add_lineKwanjai)
            formData.append('concept_detail', this.state.add_concept)
            formData.append('link_detail', this.state.add_linkMore)
            formData.append('latitude', this.state.add_latitude)
            formData.append('longitude', this.state.add_longitude)
            // formData.append('videos', JSON.stringify(this.state.values))
            // formData.append('plans', JSON.stringify(this.state.plans))
            formData.append('ImgProject', this.state.file_ImageProject)
            formData.append('ImgBanner', this.state.file_ImageBanner)
            formData.append('ImgMap', this.state.add_imgmap)
            formData.append('active_status', this.state.active ? 1 : 0)
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
        
            for (const key of Object.keys(this.state.imgCollection)) {
                formData.append('myImage', this.state.imgCollection[key])
            }
    
    
            // for (const key of Object.keys(this.state.imgCollectionPlans)) {
            //     formData.append('planImage', this.state.imgCollectionPlans[key])
            // }
            // const newPlan = this.state.plans.filter(item => item != null)
            // formData.append('plans', JSON.stringify(newPlan))
    
            // for (let i = 0; i < this.state.plansObj.length; i ++) {
            //     if(this.state.plansObj && this.state.plansObj[i] != null) formData.append('planImage', this.state.plansObj[i])
            // }
    
            this.setState({ spinner: true });
    
    
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/project_detail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        file: [null],
                        file_ImageProject: null,
                        file_ImageBanner: null,
                        file_ImageMap: null,
                        spinner:false
                    });
                }).catch(error => {
                    console.log(error)
                    this.setState({
                        spinner: false,
                        file: [null],
                        file_ImageProject: null,
                        file_ImageBanner: null,
                        file_ImageMap: null,
                    });
                    alert('แก้ไขไม่สำเร็จกรุณาลองอีกครั้ง')
                });
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    'Authorization': this.state.jwt,
                }
            };
    
            fetch(config.url.API_URL + '/project_detail/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        file: [null],
                        file_ImageProject: null,
                        file_ImageBanner: null,
                        file_ImageMap: null,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            add_name: '',
            src_project_type: '',
            src_project_name: '',
            page: 0
        });
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    async uploadMultipleFiles(e) {

            //         await this.setState({
            //     imgCollection: e.target.files
            // })

        const maxAllowedFiles = 10; // Set the maximum number of files
        const selectedFiles = e.target.files;

        if (selectedFiles.length > maxAllowedFiles) {
            document.getElementById('myImage').value = '';
            alert(`You can only upload up to ${maxAllowedFiles} files at a time.`);
        }else{
            const files = Array.from(e.target.files);
            const loadFile = (file) => {
                return new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(file);
                });
              };

            Promise.all(files.map(loadFile)).then((images) => {
                this.setState({
                    previewGallery: images
                })
            }).catch((error) => {
                console.error('Error loading files:', error);
            });

            this.setState({
                imgCollection: e.target.files
            })
        }

    }

    uploadMultipleFilesPlans(e, i) {
        if(e.target.files.length > 0){
            this.fileObj = []
            this.filePlanArray = []
            this.fileObj.push(e.target.files)
            for (let i = 0; i < this.fileObj[0].length; i++) {
                this.filePlanArray.push(URL.createObjectURL(this.fileObj[0][i]))
            }

            let filePlanObjTmp = this.state.plansObj
            filePlanObjTmp[i] = e.target.files[0]

            this.setState({
                filePlans: this.fileArray,
                imgCollectionPlans: e.target.files,
                plansObj: filePlanObjTmp
            })
        }
    }

    changeStartDate = date => {
        this.setState({
            add_start_date: date
        });
    }

    changeEndDate = date => {
        this.setState({
            add_end_date: date
        });
    }

    async change(e) {
        await this.setState({
            [e.target.name]: e.target.value
        });
    }

    changeHomeType(e) {
        this.setState({
            [e.target.name]: e.target.value,
            project_type_pages: [{ value: '', display: 'เลือกประเภทโครงการ' }],
            project_homes_pages: [{ value: '', display: 'เลือกโครงการ' }]
        });
        this.project_type(e.target.value)
    }

    changeProjectType(e) {
        this.setState({
            [e.target.name]: e.target.value,
        });
        this.project_home(e.target.value)
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    onChangeImgProject(e) {

        this.setState({ file_ImageProject: e.target.files[0] })

        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.setState({ previewProject: reader.result });
          };
          reader.readAsDataURL(file);
        }
        // validate
        // const file = e.target.files[0]
        // const options = {
        //     width: 1125,
        //     height: 1250
        // }

        // ValidateImageMatchSize(file, options).then(()=>{
        //     this.setState({ file_ImageProject: file });
        // }).catch(err => {
        //     this.setState({ file_ImageProject: null });
        //     document.getElementById('ImageProject').value = null
        //     alert(err)
        // })
    }

    onChangeImgBanner(e) {
        // validate
        this.setState({ file_ImageBanner: e.target.files[0] });

        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.setState({ previewBanner: reader.result });
          };
          reader.readAsDataURL(file);
        }
        // const file = e.target.files[0]
        // const options = {
        //     width: 1125,
        //     height: 1465
        // }

        // ValidateImageMatchSize(file, options).then(()=>{
        //     this.setState({ file_ImageBanner: file });
        // }).catch(err => {
        //     this.setState({ file_ImageBanner: null });
        //     document.getElementById('ImageBanner').value = null
        //     alert(err)
        // })
    }

    onChangeImgPlan(e) {
        // validate
        this.setState({ file_ImagePlan: e.target.files[0] });
    }

    onChangeImgMap(e) {
        this.setState({ add_imgmap: e.target.files[0] });

        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.setState({ previewMap: reader.result });
          };
          reader.readAsDataURL(file);
        }

        // this.setState({ file_ImageMap: e.target.files[0] });
        // const file = e.target.files[0]
        // const options = {
        //     width: 1125,
        //     height: 750,
        //     imgtype: ['png', 'jpg', 'jpeg'],
        //     validateType: 'both'
        // }

        // ValidateImage(file, options).then(()=>{
        //     this.setState({add_imgmap: file})
        // }).catch(err => {
        //     this.setState({ add_imgmap: null });
        //     document.getElementsByName('ImageMap')[0].value = null
        //     alert(err)
        // })

    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    addClick() {
        this.setState((prevState) => ({
            values: [...prevState.values, { link: "", description: "", type_video: 'link' }],
        }));
        //this.setState(prevState => ({ values: [...prevState.values, {link:"", detail:""}] }))
    }

    addClickPlan() {
        this.setState((prevState) => ({
            plans: [...prevState.plans, { img: "", description: "", type: 'link' }],
            plansObj: [...prevState.plansObj, null]
        }));
        //this.setState(prevState => ({ values: [...prevState.values, {link:"", detail:""}] }))
    }

    createUI() {
        return this.state.values.map((el, i) =>
            // <div key={i}>
            //     <input type="text" value={el || ''} onChange={this.handleChange.bind(this, i)} />
            //     <input type='button' value='remove' onClick={this.removeClick.bind(this, i)} />
            // </div>
            <div className="row mb-3 px-5" key={i}>
                <div className="col-sm-2 text-right">ลิงก์วีดีโอ<span style={{ color: 'red' }}>*</span> :</div>
                <div className="col-sm-3">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        // (<TextareaAutosize className="form-control" name="link" rowsMin={1} value={el.link || ''} onChange={this.handleChange.bind(this, i)} />)
                        (<textarea className="form-control" name="link" rowsMin={1} value={el.link || ''} onChange={this.handleChange.bind(this, i)} />)
                        : (<textarea className="form-control " name="link" rowsMin={1} value={el.link || ''} onChange={this.handleChange.bind(this, i)} disabled />)}
                </div>
                <div className="col-sm-2 text-right">คำอธิบาย :</div>
                <div className="col-sm-4">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        (<TextareaAutosize className="form-control" name="description" rowsMin={1} value={el.description || ''} onChange={this.handleChange.bind(this, i)} />)
                        : (<TextareaAutosize className="form-control" name="description" rowsMin={1} value={el.description || ''} onChange={this.handleChange.bind(this, i)} disabled />)}
                </div>
                <div className="col-sm-1">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        (<button className="btn-action text-center" onClick={(e) => this.removeClick(e, i)}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>)
                        : ("")}
                </div>
            </div>
        )
    }

    createUIPlan() {        
        return this.state.plans.map((el, i) =>
            // <div key={i}>
            //     <input type="text" value={el || ''} onChange={this.handleChange.bind(this, i)} />
            //     <input type='button' value='remove' onClick={this.removeClick.bind(this, i)} />
            // </div>
            <div className="row mb-3 px-5" key={i}>
                <div className="col-sm-2 text-right">รูปแปลน<span style={{ color: 'red' }}>*</span> :</div>
                <div className="col-sm-3">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        (
                            <div>
                                {el.img === '' || el.img == null ? (<></>):(<img src={el.img} alt="pic" height="auto" width="250px" />)}
                                <input type="file" className="planImgs" name="img" onChange={e => this.uploadMultipleFilesPlans(e, i)} accept="image/png, image/jpeg" />
                            </div>)
                        
                        : (<img src={el.img} alt="pic" height="auto" width="250px" />)}
                </div>
                <div className="col-sm-2 text-right">คำอธิบาย :</div>
                <div className="col-sm-4">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        (<TextareaAutosize className="form-control" name="description" rowsMin={1} value={el.description || ''} onChange={this.handlePlansChange.bind(this, i)} />)
                        : (<TextareaAutosize className="form-control" name="description" rowsMin={1} value={el.description || ''} onChange={this.handlePlansChange.bind(this, i)} disabled />)}
                </div>
                <div className="col-sm-1">
                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                        // (<button className="btn-action text-center" onClick={this.removePlansClick.bind(this, i)}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>)
                        (<button className="btn-action text-center" onClick={(e) => this.removePlansClick(e, i ,el)}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>)
                        : ("")}
                </div>
            </div>
        )
    }

    handleChange = (i, e) => {
        if (["link", "description"].includes(e.target.name)) {
            console.log("handleChange ==> IF")
            let values = [...this.state.values]
            values[i][e.target.name] = e.target.value
            this.setState({ values :values }, () => console.log(this.state.values))
        } else {
            console.log("handleChange ==> ELSE")
            this.setState({ [e.target.name]: e.target.value.toUpperCase() })
        }
    }

    handlePlansChange = (i, e) => {
        if (["img", "description"].includes(e.target.name)) {
            let val = [...this.state.plans]
            val[i][e.target.name] = e.target.value
            this.setState({ plans : val })
        } else {
            this.setState({ [e.target.name]: e.target.value.toUpperCase() })
        }
    }

    removeClick(e, i) {
        e.preventDefault();
        let values = [...this.state.values];
        const newLocal = 1;
        values.splice(i, newLocal);
        this.setState({ values });
    }

    removePlansClick(e, i ,el) {
        e.preventDefault();

        if(this.state.methodOpen === 'edit'){
            const imgId = el._id
            const path = el.img
            const data = JSON.stringify({
                path:path,
                imgId:imgId
            })
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                    "Content-Type": "application/json"
                },
                body:data
            }
            const project_detail_id = this.state.edit_id
            fetch(config.url.API_URL + '/project_detail_plansimg/' + project_detail_id,requestOptions)
                .then(res => res.json())
                .then(data => {
                    const eventPlan = new CustomEvent('fchange', {detail: i})
                    document.dispatchEvent(eventPlan)
        
                    let valFilePlanObj = this.state.plansObj
                    let oldStatePlans = this.state.plans
                    
                    valFilePlanObj.splice(i, 1);
                    oldStatePlans.splice(i, 1);
        
                    this.setState({ plans: oldStatePlans , plansObj: valFilePlanObj});
                }).catch( error => {
                    console.log(error)
                    alert("เกิดข้อผิดพลาดกรุณาติดต่อ Admin")
                });

        }else{
            const eventPlan = new CustomEvent('fchange', {detail: i})
            document.dispatchEvent(eventPlan)

            let valFilePlanObj = this.state.plansObj
            let oldStatePlans = this.state.plans
            
            valFilePlanObj.splice(i, 1);
            oldStatePlans.splice(i, 1);

            this.setState({ plans: oldStatePlans , plansObj: valFilePlanObj});
        }
        // const eventPlan = new CustomEvent('fchange', {detail: i})
        // document.dispatchEvent(eventPlan)

        // let valFilePlanObj = this.state.plansObj
        // let oldStatePlans = this.state.plans
        
        // valFilePlanObj.splice(i, 1);
        // oldStatePlans.splice(i, 1);

        // this.setState({ plans: oldStatePlans , plansObj: valFilePlanObj});
        
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);


        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Project Detail List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Project Detail</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {/* {(this.state.user_permission[143].permission == 1 && <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>)} */}
                                    <ExcelFile filename="projectdetail" element={(
                                        this.state.user_permission[242].permission == 1 && <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="projectdetail">
                                            <ExcelColumn label="โครงการ" value={(col) => col.project_type_name} />
                                            <ExcelColumn label="ชื่อโครงการ" value={(col) => col.project_name} />
                                            <ExcelColumn label="ชื่อแบนเนอร์" value={(col) => col.title} />
                                            <ExcelColumn label="ภาพแบนเนอร์" value={(col) => col.img} />
                                            <ExcelColumn label="concept" value={(col) => col.concept} />
                                            <ExcelColumn label="วันที่สร้าง" value={(col) => col.create} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(เวลา)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                                <div className="card-body">
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                            <Table aria-label="MGMTable">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>แบรนด์</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ชื่อโครงการ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ชื่อแบนเนอร์</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ภาพแบนเนอร์</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>วันที่สร้าง</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>สถานะการใช้งาน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                                return (
                                                                    <StyledTableRow key={`1${i}`}>
                                                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.num}</StyledTableCell>
                                                                        <StyledTableCell>{data.project_type_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.title}</StyledTableCell>
                                                                        <StyledTableCell style={{ textAlign: 'center' }}><img src={data.img} alt="pic" height="100" width="auto" style={{ verticalAlign: "text-top" }} /></StyledTableCell>
                                                                        <StyledTableCell>{data.create}</StyledTableCell>
                                                                        <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                        {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                        {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                        <StyledTableCell>
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                            {(this.state.user_permission[144].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                            )}
                                                                            {/* {(this.state.user_permission[145].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                            )} */}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>)
                                                            })
                                                    }

                                                    {emptyRows > 0 && (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={6} />
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50]}
                                                component="div"
                                                count={this.state.pages.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl" enforceFocus={false}>
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">

                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right" >ประเภทโครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    <div className="form-control">{this.state.add_home_name}</div>
                                    {/* {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_home_type" onChange={this.changeHomeType}>
                                            {this.state.home_type_pages.map((data, i) => <option key={i} value={data.value} selected={this.state.add_home_type === data.value && "selected"}>{data.display}</option>)}
                                        </select>) : (<div className="form-control">{this.state.add_home_name}</div>)} */}
                                </div>
                                <div className="col-sm-2 text-right">แบรนด์ :</div>
                                <div className="col-sm-4">
                                    <div className="form-control">{this.state.add_project_name}</div>
                                    {/* {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_project_type" onChange={this.changeProjectType}>
                                            {this.state.project_type_pages.map((data, i) => <option key={i} value={data.value} selected={this.state.add_project_type === data.value && "selected"}>{data.display}</option>)}
                                        </select>) : (<div className="form-control">{this.state.add_project_name}</div>)} */}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">ชื่อโครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    <div className="form-control">{this.state.add_projectname_name}</div>
                                    {/* {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_project_name" onChange={this.change}>
                                            {this.state.project_homes_pages.map((data, i) => <option key={i} value={data.value} selected={this.state.add_project_name === data.value && "selected"}>{data.display}</option>)}
                                        </select>) : (<div className="form-control">{this.state.add_projectname_name}</div>)} */}
                                </div>
                                <div className="col-sm-2 text-right">ชื่อแบนเนอร์ :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_banner" name="add_banner" accept="image/png, image/jpeg" defaultValue={this.state.add_banner} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_banner}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">ภาพโครงการ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-4">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (
                                            <>
                                                {this.state.previewProject && (
                                                <div>
                                                    <img src={this.state.previewProject} alt="preview" width="250" height="auto" style={{ObjectFit:'cover'}} />
                                                </div>
                                                )}
                                                <div>
                                                    <input type="file" id="ImageProject" name="ImageProject" onChange={this.onChangeImgProject} accept="image/png, image/jpeg" />
                                                </div>
                                            </>
                                            // <input type="file" id="ImageProject" name="ImageProject" onChange={this.onChangeImgProject} accept="image/png, image/jpeg" />
                                        )
                                        : (<img src={this.state.add_img} alt="pic" height="auto" width="100%" />)}
                                </div>
                                <div className="col-sm-2 text-right">รูปแบนเนอร์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-4">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (
                                            <>
                                                {this.state.previewBanner && (
                                                <div>
                                                    <img src={this.state.previewBanner} alt="preview" width="250" height="auto" style={{ObjectFit:'cover'}} />
                                                </div>
                                                )}
                                                <div>
                                                    <input type="file" id="ImageBanner" name="ImageBanner" onChange={this.onChangeImgBanner} accept="image/png, image/jpeg" />
                                                </div>
                                            </>
                                        )
                                        : (<img src={this.state.add_imgbanner} alt="pic" height="auto" width="100%" />)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-6 text-right"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ : แนะนำไฟล์ JPG,PNG ขนาด 1125*1250px </span></div>
                                <div className="col-sm-6 text-right"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ : แนะนำไฟล์ JPG,PNG ขนาด 1125*1465px </span></div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">ลิงก์แบนเนอร์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input className="form-control" name="add_linkBanner" rowsMin={1} defaultValue={this.state.add_linkBanner} onChange={this.change} />)
                                        : (<input className="form-control" name="add_linkBanner" rowsMin={1} defaultValue={this.state.add_linkBanner} onChange={this.change} disabled />)}
                                </div>
                                <div className="col-sm-2 text-right">Line Kwanjai<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<TextareaAutosize className="form-control" name="add_lineKwanjai" rowsMin={1} defaultValue={this.state.add_lineKwanjai} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_lineKwanjai" rowsMin={1} defaultValue={this.state.add_lineKwanjai} onChange={this.change} disabled />)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-1 text-right" style={{ textDecoration: "underline" }}>Concept</div>
                                <div className="col-sm-3"></div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">Concept :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<TextareaAutosize className="form-control" name="add_concept" rowsMin={1} defaultValue={this.state.add_concept} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_concept" rowsMin={1} defaultValue={this.state.add_concept} onChange={this.change} disabled />)}
                                </div>
                                <div className="col-sm-2 text-right">ข้อมูลเพิ่มเติม ลิงก์ :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<TextareaAutosize className="form-control" name="add_linkMore" rowsMin={1} defaultValue={this.state.add_linkMore} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_linkMore" rowsMin={1} defaultValue={this.state.add_linkMore} onChange={this.change} disabled />)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-1 text-right" style={{ textDecoration: "underline" }}>Gallery</div>
                                <div className="col-sm-3"></div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">Gallery<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-10">
                                {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ? (
                                    <>
                                        <input
                                            type="file"
                                            name="myImage"
                                            id='myImage'
                                            onChange={this.uploadMultipleFiles}
                                            multiple
                                            accept="image/png, image/jpeg"
                                        />
                                        <div>
                                        {this.state.previewGallery.map((image, index) => (
                                            <img
                                            key={index}
                                            className="cover-image" // Add the CSS class for object-fit
                                            src={image}
                                            alt={`preview-${index}`}
                                            width="150"
                                            height="auto"
                                            />
                                        ))}
                                        </div>
                                    </>
                                    ) : (
                                        this.state.imgGalleryPreviewArr).map((img, i) => (
                                            <img key={i} src={img.image} alt="..." height="150" width="auto" style={{marginInline:"5px"}}/>
                                        )
                                    )}

                                </div>
                            </div>
                            {/* <div className="row mb-3 px-5">
                                <div className="col-sm-3 text-right"></div>
                                <div className="col-sm-9">
                                    {(this.state.imgGalleryPreviewArr).map((img, i) => (
                                        <img key={i} src={img.image} alt="..." height="150" width="auto" style={{marginInline:"5px"}}/>
                                    ))}
                                </div>
                            </div> */}
                            <div className="row mb-3 px-5">
                                <div className="col-sm-7 text-center"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ : แนะนำไฟล์ JPG,PNG 1125*750 px </span></div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-1 text-right" style={{ textDecoration: "underline" }}>Map</div>
                                <div className="col-sm-3"></div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">Latitude :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_latitude" name="add_latitude" defaultValue={this.state.add_latitude} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_latitude}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">Longitude :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_longitude" name="add_longitude" defaultValue={this.state.add_longitude} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_longitude}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">Map Graphic<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-10">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (
                                        <>
                                            {this.state.previewMap && (
                                            <div>
                                                <img src={this.state.previewMap} alt="preview" width="250" height="auto" style={{ObjectFit:'cover'}} />
                                            </div>
                                            )}
                                            <div>
                                            <input type="file" name="ImageMap" onChange={this.onChangeImgMap} accept="image/png, image/jpeg" />
                                            </div>
    
                                        </>
                                        // <input type="file" name="ImageMap" onChange={this.onChangeImgMap} accept="image/png, image/jpeg" />
                                        )
                                        : (<img src={this.state.add_imgmap} alt="pic" height="200" width="auto" />)}
                                </div>
                            </div>
                            <div className="row mb-3 px-5">
                                <div className="col-sm-6 text-right"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ : แนะนำไฟล์ JPG,PNG 1125*750px / 750*1125px </span></div>
                            </div>

                            {/* <div className="row mb-3 px-5">
                                <div className="col-sm-1 text-right" style={{ textDecoration: "underline" }}>Review </div>
                                {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                    (<input className="btn-action" value='+ Add more' onClick={this.addClick.bind(this)} />)
                                    : ("")}
                                <div className="col-sm-3"></div>
                            </div>

                            {this.createUI()}

                            <div className="row mb-3 px-5">
                                <div className="col-sm-1 text-right" style={{ textDecoration: "underline" }}>รูปแปลน </div>
                                {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                    (<input className="btn-action" value='+ Add more' onClick={this.addClickPlan.bind(this)} />)
                                    : ("")}
                                <div className="col-sm-3"></div>
                            </div>

                            {this.createUIPlan()} */}
                            
                            {/* <div className="row mb-3">
                                <div className="col-sm-2 text-right">ลิงก์วีดีโอ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_linkVideo" name="add_linkVideo" defaultValue={this.state.add_linkVideo} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_linkVideo" rowsMin={2} defaultValue={this.state.add_linkVideo} onChange={this.change} disabled />)}
                                </div>
                                <div className="col-sm-2 text-right">คำอธิบาย :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<TextareaAutosize className="form-control" name="add_VideoDescription" rowsMin={2} defaultValue={this.state.add_VideoDescription} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_VideoDescription" rowsMin={2} defaultValue={this.state.add_VideoDescription} onChange={this.change} disabled />)}
                                </div>
                            </div> */}
                            <div className="row mb-3 px-5">
                                <div className="col-sm-2 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >แบรนด์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="src_project_type" onChange={this.changeProjectType}>
                                        {this.state.project_types.map((data, i) => <option key={i} value={data.value} selected={this.state.src_project_type === data.value && "selected"}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >ชื่อโครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="src_project_name" onChange={this.change}>
                                        {this.state.project_home.map((data, i) => <option key={i} value={data.value} selected={this.state.src_project_name === data.value && "selected"}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อแบนเนอร์</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name" name="add_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>

                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}